<template>
  <v-main id="cenas">
    <v-container fluid>
      <div>
        <v-btn
          depressed
          color="#D8E0E6"
          class="gray-button pag-btn return-btn"
          to="/home"
          ><v-icon size="10" left>$icon-arrow-left</v-icon> Voltar</v-btn
        >
      </div>
      <v-row style="height: 100%;">
        <!-- LEFT COLUMN -->
        <v-col class="left-col flex-center">
          <!-- LOGO -->
          <div class="logo">
            <v-img src="../assets/images/logo.svg"></v-img>
          </div>
          <div>
            <!-- BANNER IMAGE -->
            <v-row class="login-img" align="center" justify="center">
              <v-col
                cols="10"
                style="padding: 0"
                align="center"
                justify="center"
              >
                <img
                  class="banner"
                  src="../assets/images/login.png"
                  style="width:100%;"
                />
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="8" align="center" justify="center">
                <div class="text-center big-title">
                  Soa o
                  <a>appito</a> em campo.
                </div>
                <div class="text-center small-title">
                  Dê o pontapé de saída. Para entrar na sua conta, faça login.
                </div>
              </v-col>
            </v-row>
            <!-- EMAIL -->
            <v-row align="center" justify="center">
              <v-col class="form-col" style="padding-bottom:4px !important;">
                <v-text-field
                  filled
                  dense
                  height="48"
                  placeholder="Email"
                  :hide-details="!input.email.error"
                  :error-messages="input.email.errorText"
                  name="username"
                  type="email"
                  class="login-register-text"
                  v-model="input.email.value"
                  :append-icon="
                    input.email.error
                      ? '$icon-circle-error'
                      : input.email.valid
                      ? '$icon-circle-check'
                      : ''
                  "
                  @input="validateEmail(false)"
                  v-bind:class="{
                    'input-success': input.email.valid,
                    'input-error': input.email.error
                  }"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- PASSWORD -->
            <v-row align="center" justify="center">
              <v-col class="form-col" style="padding-top:4px !important;">
                <v-text-field
                  filled
                  dense
                  height="48"
                  placeholder="Password"
                  :hide-details="!input.password.error"
                  :error-messages="input.password.errorText"
                  name="password"
                  class="login-register-text"
                  v-model="input.password.value"
                  :append-icon="
                    input.password.error
                      ? '$icon-circle-error'
                      : input.password.valid
                      ? '$icon-circle-check'
                      : ''
                  "
                  @input="validatePassword(false)"
                  v-bind:class="{
                    'input-success': input.password.valid,
                    'input-error': input.password.error
                  }"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
                <!--                     :append-icon="showPassword ? '$icon-eye' : '$icon-eye-off'" -->
              </v-col>
            </v-row>
            <!-- LOGIN BUTTON -->
            <v-row align="center" justify="center">
              <v-col class="flex-center">
                <v-btn
                  large
                  depressed
                  color="primary"
                  class="regular-btn"
                  :loading="loading"
                  :disabled="loading"
                  @click="validate()"
                  >Login</v-btn
                >
              </v-col>
            </v-row>
            <!-- RECOVER / REGISTER -->
            <v-row align="center" justify="center">
              <v-col style="padding-top: 4px !important;">
                <v-list-item to="/recuperar-password">
                  <v-list-item-subtitle class="text-center light-text"
                    >Esqueceu-se da sua password?</v-list-item-subtitle
                  >
                </v-list-item>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- RIGHT COLUMN -->
        <v-col class="right-col flex-center">
          <div style="width: 100%;">
            <v-row>
              <v-col>
                <v-img
                  src="../assets/images/login.png"
                  aspect-ratio="1"
                  contain
                ></v-img>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="snackBarTimeout" color="error">{{
      errorText
    }}</v-snackbar>
  </v-main>
</template>

<style scoped>
.v-main {
  height: calc(100vh - 2px);
  padding: 0px 256px 0px 0px;
  position: absolute;
  width: 100vw;
  top: -14px;
  padding: 0 !important;
  left: 0;
}
.container {
  height: 100%;
  padding: 0 !important;
}
.left-col {
  flex: 0 0 55%;
  max-width: 55%;
  background-color: #ffffff;
}
.return-btn {
  position: fixed;
  top: 24px;
  left: 32px;
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #9aabb8;
  text-transform: capitalize;
  width: 176px;
  z-index: 99;
}
.right-col {
  flex: 0 0 45%;
  max-width: 45%;
}
.big-title {
  font-family: Gilroy-SemiBold;
  font-size: 20px;
  line-height: 24px;
}
.small-title {
  font-family: Gilroy-SemiBold;
  color: #6d818f;
  font-size: 14px;
  line-height: 16px;
}
.v-list-item {
  min-height: initial !important;
}
.light-text {
  color: #bcc5cc !important;
  font-size: 12px;
  line-height: 16px;
}
.align-bottom {
  margin-top: 0;
}
.v-image >>> .v-responsive__sizer {
  max-height: 250px !important;
}
.logo {
  position: absolute;
  left: calc(27.5% - 31px);
  top: 136px;
}
.login-img {
  display: none;
}
.form-col {
  flex: 0 0 380px;
  max-width: 380px;
}
@media only screen and (max-height: 1024px) {
  .banner {
    max-width: 312px;
    margin-top: 22px;
  }
}
@media only screen and (max-height: 812px) {
  .banner {
    max-width: 264px;
    margin-top: 22px;
  }
}
@media only screen and (max-width: 768px) {
  .right-col {
    display: none;
  }
  .left-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .login-img {
    display: flex;
  }
  .return-btn {
    width: 106px;
  }
  .form-col {
    flex: 0 0 90%;
    max-width: 90%;
  }
  .logo {
    position: absolute;
    left: 50%;
    top: 84px;
  }
  .logo .v-image {
    position: relative;
    left: -50%;
  }
  .form-actions {
    position: absolute;
    left: 50%;
    bottom: 24px;
  }
  .form-actions .row {
    position: relative;
    left: -50%;
  }
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #26ab5e !important;
  color: #ffffff !important;
}
.v-btn:not(.v-btn--round).v-size--large {
  height: 48px;
}
</style>

<script>
import { FirebaseApp } from "../auth";

export default {
  props: {
    source: String
  },
  components: {},
  data: () => ({
    validEmail: false,
    emailError: false,
    errorText: "",
    showPassword: false,
    snackbar: false,
    snackBarTimeout: 3000,
    loading: false,
    input: {
      email: {
        value: "",
        valid: false,
        error: false,
        errorText: ""
      },
      password: {
        value: "",
        valid: false,
        error: false,
        errorText: ""
      }
    },
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: v =>
        /.+@.+\..+/.test(v) || "The email and password you entered don't match"
    }
  }),
  methods: {
    validate() {
      const validEmail = this.validateEmail(true);
      const validPass = this.validatePassword(true);
      if (validEmail && validPass) {
        this.login();
      }
    },
    validateEmail(fromButton) {
      if (/.+@.+\..+/.test(this.input.email.value)) {
        this.input.email.valid = true;
        this.input.email.error = "";
        return true;
      } else {
        this.input.email.valid = false;
        if (fromButton) {
          this.input.email.error = true;
          this.input.email.errorText = "Email inválido";
        }
        return false;
      }
    },
    validatePassword(fromButton) {
      if (
        this.input.password.value.length > 8 &&
        /(?=.*[A-Z])/.test(this.input.password.value) &&
        /(?=.*\d)/.test(this.input.password.value) &&
        /([!@$%])/.test(this.input.password.value)
      ) {
        this.input.password.valid = true;
        this.input.password.error = "";
        return true;
      } else {
        this.input.password.valid = false;
        if (fromButton) {
          this.input.password.error = true;
          this.input.password.errorText =
            "Password tem de ter pelo menos 8 caracters, uma maiúscula, um número e um caracter especial [!@#$%]";
        }
        return false;
      }
    },
    login() {
      this.loading = true;
      FirebaseApp.auth()
        .signInWithEmailAndPassword(
          this.input.email.value,
          this.input.password.value
        )
        .then(() => {
          console.log("Firebase OK");
          this.$router.replace("/");
        })
        .catch(error => {
          this.loading = false;
          if (
            error.code === "auth/wrong-password" ||
            error.code === "auth/user-not-found" ||
            error.code === "auth/invalid-email"
          ) {
            this.input.email.errorText = "O email e/ou a password errados";
            this.input.email.error = true;
          } else if (error.code === "auth/too-many-requests") {
            this.errorText =
              "Demasiadas tentativas sem êxito. Por favor, tente mais tarde.";
            this.snackbar = true;
          } else if (error.code === "auth/argument-error") {
            this.errorText = "Dados inválidos";
            this.snackbar = true;
          } else if (error.code === "auth/user-disabled") {
            this.errorText = "Esta conta foi removida/desactivada!";
            this.snackbar = true;
          } else {
            this.errorText = "Erro ao contactar o servidor. pedimos desculpas!";
            this.snackbar = true;
          }

          console.error(error);
          console.log(this.errorText);
          return false;
        });
    }
  }
};
</script>